import type { AdminApp } from './api'

const statusTagClassName: Record<string, string> = {
  active: 'border-[#d9f7be] bg-[#f6ffed] text-[#16823c]',
  banned: 'border-[#ffccc7] bg-[#fff1f0] text-[#b42318]',
  draft: 'border-[rgba(26,28,25,0.15)] bg-white text-[rgba(26,28,25,0.88)]',
  pending_publish: 'border-[#ffe58f] bg-[#fffbe6] text-[#b76a00]',
  testing: 'border-[#91caff] bg-[#e6f4ff] text-[#195bff]',
}

export function AdminAppNameCell({ app, subtitle }: { app: AdminApp; subtitle?: string }) {
  const initial = Array.from(app.name.trim())[0]?.toUpperCase() ?? '?'
  const fallbackSubtitle = (app.tags ?? []).map((tag) => tag.name).join('，')
  const resolvedSubtitle = subtitle ?? fallbackSubtitle

  return (
    <div className="flex min-w-[210px] items-center gap-2.5">
      {app.avatar ? (
        <img
          alt={app.name}
          className="size-9 shrink-0 rounded-[4px] bg-[#e2e9ff] object-cover"
          src={app.avatar}
        />
      ) : (
        <span
          aria-hidden
          className="inline-flex size-9 shrink-0 items-center justify-center rounded-[4px] bg-[#e2e9ff] text-sm leading-none font-normal text-[#195bff]"
          title={app.name}
        >
          {initial}
        </span>
      )}
      <div className="min-w-0">
        <span className="block truncate text-[#1a1c19]">{app.name}</span>
        {resolvedSubtitle ? (
          <span className="mt-0.5 block max-w-[240px] truncate text-xs text-[#8c8e90]">
            {resolvedSubtitle}
          </span>
        ) : null}
      </div>
    </div>
  )
}

export function AdminAppStatusCell({ status, text }: { status: string; text: string }) {
  return (
    <span
      className={[
        'inline-flex h-[22px] items-center rounded-[4px] border px-2 text-xs leading-5 font-normal whitespace-nowrap',
        statusTagClassName[status] ?? statusTagClassName.draft,
      ].join(' ')}
    >
      {text}
    </span>
  )
}
